import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, MenuItem, TextField } from "@mui/material";
import { useContext } from "react";
import { schedulingContext } from '../SchedulingContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { IoChevronBackOutline as BackIcon, IoChevronForwardOutline as ForwardIcon } from 'react-icons/io5';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import moment from "moment";
import { FilterContainer } from "components";
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { applicationContext } from "helpers/services";

let Filter = () => {
    let { formatMessage } = useIntl();
    let service = useContext(schedulingContext);
    let appService = useContext(applicationContext);

    let handleUserNamesChange = (e: any) => {
        let selectValue: string[] = e.target.value;
        if (selectValue.indexOf('') >= 0) {
            selectValue = [];
        }
        let request = {
            ...service.search,
            userNames: selectValue
        }
        service.handleChange(request);
    }

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item>
                <Button
                    type="button"
                    color="secondary"
                    variant="outlined"
                    size="large"
                    onClick={() => service.dateBackHandler()}
                >
                    <BackIcon />
                </Button>
            </Grid>
            <Grid item>
                <DateRangePicker
                    startText="Da data"
                    endText="A data"
                    value={[service.search.dateFrom, service.search.dateTo]}
                    onChange={(newValue: DateRange<Date>) => {
                        service.handleChange({
                            ...service.search,
                            dateFrom: moment(newValue[0]).utc(true),
                            dateTo: moment(newValue[1]).utc(true)
                        })
                    }}
                    renderInput={(startProps, endProps) => (
                        <>
                            <TextField {...startProps} variant="standard" />
                            <Box sx={{ ml: 1.5 }} />
                            <TextField {...endProps} variant="standard" />
                        </>
                    )}
                />
            </Grid>
            <Grid item>
                <Button
                    type="button"
                    color="secondary"
                    variant="outlined"
                    size="large"
                    onClick={() => service.dateForwardHandler()}
                >
                    <ForwardIcon />
                </Button>
            </Grid>
            <Grid item>
                <Button
                    type="button"
                    color="secondary"
                    variant="outlined"
                    onClick={() => service.selectWeek()}
                >
                    {formatMessage({ id: LocalizationIds.Week })}
                </Button>
            </Grid>
            <Grid item>
                <Button
                    type="button"
                    color="secondary"
                    variant="outlined"
                    onClick={() => service.selectMonth()}
                >
                    {formatMessage({ id: LocalizationIds.Month })}
                </Button>
            </Grid>
            <Divider orientation="vertical" flexItem ></Divider>
            <Grid item>
                <TextField
                    select
                    variant="standard"
                    SelectProps={{
                        multiple: true,
                        onChange: handleUserNamesChange
                    }}
                    name="filter"
                    label={formatMessage({ id: LocalizationIds.Technician })}
                    value={service.search.userNames}
                >
                    <MenuItem value={''}>{formatMessage({ id: LocalizationIds.Any })}</MenuItem>
                    {appService.simecUsers
                        .filter(x => x.isDisabled === false)
                        .filter(x => x.simecClaims.canGoToCustomer === true)
                        .map(u => <MenuItem key={u.email} value={u.email}>{u.fullName}</MenuItem>)}
                </TextField>
            </Grid>
            <Grid item>
                <FormControlLabel
                    label={formatMessage({ id: LocalizationIds.ShowEmptyRows })}
                    name="showEmpty"
                    control={<Checkbox
                        checked={service.search.showEmpty}
                        onChange={(e, value) => service.handleChange({ ...service.search, showEmpty: value === true ? true : false })}
                        name="showEmpty"
                        color="secondary"
                    />}
                />
            </Grid>
            <Grid item>
                <Button type="submit" variant="contained" size="large">
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;